import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from 'src/app/app.reducer';
import { TicketHistory } from 'src/app/core/models/itinerary.model';

import { TicketHistoryActions } from '../actions';
import * as fromReducer from '../reducers/pnr.reducer';

@Injectable()
export class TicketHistoryService {

  constructor(private store: Store<State>) { }

  getTicketHistory(): Observable<TicketHistory[]> {
    return this.store.pipe(select(fromReducer.getTicketHistory));
  }

  dispatchLoadTicketHistorySuccess(ticketHistory: TicketHistory[]) {
    this.store.dispatch(TicketHistoryActions.LoadTicketHistorySuccess({ticketHistory}));
  }

}